export abstract class FlyingFocus {
  abstract focus(element: Element);
}
